import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUser } from "../services/deleteUserService";

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listUser"] });
    },
    onError: (error) => {
      console.error("Failed to delete user:", error);
    },
  });
};